var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "el-card",
        [
          _c(
            "el-form",
            { attrs: { inline: "", size: "mini" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "流量分发模型" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "240px" },
                      attrs: {
                        placeholder: "流量分发模型",
                        multiple: "",
                        clearable: "",
                        filterable: "",
                        "collapse-tags": "",
                      },
                      model: {
                        value: _vm.searchPatterns,
                        callback: function ($$v) {
                          _vm.searchPatterns = $$v
                        },
                        expression: "searchPatterns",
                      },
                    },
                    _vm._l(_vm.patterns, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.onSelectAllPatterns } }, [
                    _vm._v("\n                    全选\n                "),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "流量分发部门" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "240px" },
                      attrs: {
                        placeholder: "流量分发部门",
                        filterable: "",
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.searchGuides,
                        callback: function ($$v) {
                          _vm.searchGuides = $$v
                        },
                        expression: "searchGuides",
                      },
                    },
                    _vm._l(_vm.guideDepartments, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { on: { click: _vm.onSelectAllGuideDepartments } },
                    [_vm._v("\n                    全选\n                ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "流量接收部门" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "240px" },
                      attrs: {
                        placeholder: "流量接收部门",
                        filterable: "",
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.searchAccepts,
                        callback: function ($$v) {
                          _vm.searchAccepts = $$v
                        },
                        expression: "searchAccepts",
                      },
                    },
                    _vm._l(_vm.acceptDepartments, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { on: { click: _vm.onSelectAllAcceptDepartments } },
                    [_vm._v("\n                    全选\n                ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "渠道分类" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "240px" },
                      attrs: {
                        placeholder: "渠道分类",
                        filterable: "",
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.searchChannelGroups,
                        callback: function ($$v) {
                          _vm.searchChannelGroups = $$v
                        },
                        expression: "searchChannelGroups",
                      },
                    },
                    _vm._l(_vm.channelGroups, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { on: { click: _vm.onSelectAllChannelGroups } },
                    [_vm._v("\n                    全选\n                ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "测算支付日期" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "picker-options": _vm.pickerOptions,
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "default-time": _vm.defaultTime,
                    },
                    model: {
                      value: _vm.paidDateRange,
                      callback: function ($$v) {
                        _vm.paidDateRange = $$v
                      },
                      expression: "paidDateRange",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "加粉日期" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "picker-options": _vm.pickerOptions,
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "default-time": _vm.defaultTime,
                    },
                    model: {
                      value: _vm.fansDataRange,
                      callback: function ($$v) {
                        _vm.fansDataRange = $$v
                      },
                      expression: "fansDataRange",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            { attrs: { size: "mini" } },
            [
              _vm.dimensions.length > 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "维度" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.searchDimensions,
                            callback: function ($$v) {
                              _vm.searchDimensions = $$v
                            },
                            expression: "searchDimensions",
                          },
                        },
                        _vm._l(_vm.dimensions, function (item) {
                          return _c(
                            "el-checkbox",
                            { key: item.value, attrs: { label: item.value } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(item.label) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        plain: "",
                        icon: "el-icon-search",
                      },
                      on: { click: _vm.onSearch },
                    },
                    [_vm._v("\n                    搜索\n                ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "info",
                        icon: "el-icon-refresh",
                        plain: "",
                      },
                      on: { click: _vm.onReset },
                    },
                    [_vm._v("\n                    重置\n                ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "section-title" }, [
        _vm._v("\n        链路指标\n    "),
      ]),
      _vm._v(" "),
      _c(
        "el-card",
        { staticStyle: { "margin-bottom": "30px" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("div", [
                _c("div", { staticClass: "card-title" }, [
                  _vm._v("链路转化漏斗"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-tips" }, [
                  _vm._v(
                    "\n                    所有参照比率均以测算订单数为分母，同时展示上一层到下一层的转化率\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.funnelData.length > 0
                ? _c("div", { staticClass: "stat-card" }, [
                    _c("div", { staticClass: "stat-card-value" }, [
                      _c("span", [_vm._v(_vm._s(_vm.funnelData[7].baseRate))]),
                      _vm._v("\n                    加粉率\n                "),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-card-detail" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.funnelData[7].count) +
                          " / " +
                          _vm._s(_vm.funnelData[0].count) +
                          " 单\n                "
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("FunnelChart", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loadingFunnelData,
                expression: "loadingFunnelData",
              },
            ],
            attrs: { list: _vm.funnelData },
            on: { "item-click": _vm.onFunnelClick },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "section-title" }, [
        _vm._v("\n        " + _vm._s(_vm.summaryTitle) + "\n        "),
        _c("span", [_vm._v("每个维度值独立计算，基准为该维度测算订单数")]),
      ]),
      _vm._v(" "),
      _c(
        "el-card",
        { staticStyle: { "margin-bottom": "30px" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("div", [
                _c("div", { staticClass: "card-title" }, [
                  _vm._v("强导数据链路汇总"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-tips" }, [
                  _vm._v(
                    "\n                    按当前筛选条件汇总，可直接导出\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    plain: "",
                    type: "success",
                    icon: "el-icon-download",
                  },
                  on: { click: _vm.onExportFunnelData },
                },
                [_vm._v("\n                导出链路数据\n            ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingFunnelData,
                  expression: "loadingFunnelData",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.funnelData,
                border: "",
                "header-cell-style": _vm.getHeaderCellStyle,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "链路环节",
                  prop: "title",
                  fixed: "",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "环节说明", prop: "desc", "min-width": "180" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "订单数", prop: "count", "min-width": "150" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "基准占比",
                  prop: "baseRate",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "上一层转化率",
                  prop: "upperRate",
                  "min-width": "120",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showDimensionTable,
              expression: "showDimensionTable",
            },
          ],
          staticStyle: { "margin-bottom": "30px" },
        },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("div", [
                _c("div", { staticClass: "card-title" }, [
                  _vm._v("强导数据链路明细"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-tips" }, [
                  _vm._v(
                    "\n                    表格列展示所选维度的具体文案内容\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    plain: "",
                    type: "success",
                    icon: "el-icon-download",
                    loading: _vm.isExportingDimensionTable,
                  },
                  on: { click: _vm.onExportDimensionData },
                },
                [_vm._v("\n                导出维度数据\n            ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingDimensionData,
                  expression: "loadingDimensionData",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.dimensionData,
                border: "",
                "max-height": "750",
                "header-cell-style": _vm.getHeaderCellStyle,
              },
            },
            [
              _vm.showPatternColumn
                ? _c("el-table-column", {
                    attrs: {
                      label: "流量分发模型",
                      prop: "pattern_name",
                      "min-width": "150",
                      fixed: "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showGuideColumn
                ? _c("el-table-column", {
                    attrs: {
                      label: "流量分发部门",
                      prop: "daofen_department",
                      "min-width": "140",
                      fixed: "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showAcceptColumn
                ? _c("el-table-column", {
                    attrs: {
                      label: "流量接收部门",
                      prop: "jiefen_department",
                      "min-width": "140",
                      fixed: "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showChannelColumn
                ? _c("el-table-column", {
                    attrs: {
                      label: "渠道分类",
                      prop: "channel_zaiti",
                      "min-width": "140",
                      fixed: "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dimensionMetrics, function (metric) {
                return _c("el-table-column", {
                  key: metric.rateKey,
                  attrs: {
                    label: metric.label,
                    "min-width": metric.width || 130,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "count" }, [
                              _vm._v(_vm._s(scope.row[metric.countKey])),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "percent" }, [
                              _vm._v(_vm._s(scope.row[metric.rateKey])),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showFailedTable
        ? _c(
            "el-card",
            [
              _c(
                "div",
                {
                  staticClass: "card-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v("加粉不成功订单明细"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        plain: "",
                        type: "success",
                        icon: "el-icon-download",
                        loading: _vm.isExportingFailedTable,
                      },
                      on: { click: _vm.onExportFailedData },
                    },
                    [_vm._v("\n                导出数据\n            ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loadingFailedData,
                      expression: "loadingFailedData",
                    },
                  ],
                  ref: "failedTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.displayFailedData,
                    border: "",
                    "max-height": "750",
                    "header-cell-style": _vm.getHeaderCellStyle,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "订单号",
                      prop: "order_id",
                      width: "240",
                      align: "center",
                      fixed: "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header-title" }, [
                                _vm._v("订单号"),
                              ]),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: {
                                  size: "mini",
                                  placeholder: "筛选订单号",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.filterFailedOrderNo,
                                  callback: function ($$v) {
                                    _vm.filterFailedOrderNo = $$v
                                  },
                                  expression: "filterFailedOrderNo",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(scope.row.order_id) +
                                  "\n                "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3918173096
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "流量分发模型",
                      prop: "pattern_name",
                      width: "200",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header-title" }, [
                                _vm._v("流量分发模型"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    size: "mini",
                                    placeholder: "筛选流量分发模型",
                                    clearable: "",
                                    filterable: "",
                                  },
                                  model: {
                                    value: _vm.filterFailedPattern,
                                    callback: function ($$v) {
                                      _vm.filterFailedPattern = $$v
                                    },
                                    expression: "filterFailedPattern",
                                  },
                                },
                                _vm._l(
                                  _vm.failedTableFilters.pattern_name,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(scope.row.pattern_name) +
                                  "\n                "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2742140500
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "流量分发部门",
                      prop: "daofen_department",
                      width: "200",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header-title" }, [
                                _vm._v("流量分发部门"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    size: "mini",
                                    placeholder: "筛选流量分发部门",
                                    clearable: "",
                                    filterable: "",
                                  },
                                  model: {
                                    value: _vm.filterFailedGuide,
                                    callback: function ($$v) {
                                      _vm.filterFailedGuide = $$v
                                    },
                                    expression: "filterFailedGuide",
                                  },
                                },
                                _vm._l(
                                  _vm.failedTableFilters.daofen_department,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(scope.row.daofen_department) +
                                  "\n                "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1222681030
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "流量接收部门",
                      prop: "jiefen_department",
                      width: "200",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header-title" }, [
                                _vm._v("流量接收部门"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    size: "mini",
                                    placeholder: "筛选流量接收部门",
                                    clearable: "",
                                    filterable: "",
                                  },
                                  model: {
                                    value: _vm.filterFailedAccept,
                                    callback: function ($$v) {
                                      _vm.filterFailedAccept = $$v
                                    },
                                    expression: "filterFailedAccept",
                                  },
                                },
                                _vm._l(
                                  _vm.failedTableFilters.jiefen_department,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(scope.row.jiefen_department) +
                                  "\n                "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3988856508
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "渠道分类",
                      prop: "channel_zaiti",
                      align: "center",
                      width: "200",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header-title" }, [
                                _vm._v("渠道分类"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    size: "mini",
                                    placeholder: "筛选渠道分类",
                                    clearable: "",
                                    filterable: "",
                                  },
                                  model: {
                                    value: _vm.filterFailedChannelGroup,
                                    callback: function ($$v) {
                                      _vm.filterFailedChannelGroup = $$v
                                    },
                                    expression: "filterFailedChannelGroup",
                                  },
                                },
                                _vm._l(
                                  _vm.failedTableFilters.channel_zaiti,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(scope.row.channel_zaiti) +
                                  "\n                "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1703483808
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "测算支付日期",
                      prop: "order_time",
                      "min-width": "380",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header-title" }, [
                                _vm._v("测算支付日期"),
                              ]),
                              _vm._v(" "),
                              _c("el-date-picker", {
                                attrs: {
                                  type: "daterange",
                                  size: "mini",
                                  "range-separator": "至",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  "picker-options": _vm.pickerOptions,
                                },
                                model: {
                                  value: _vm.filterFailedPaidDateRange,
                                  callback: function ($$v) {
                                    _vm.filterFailedPaidDateRange = $$v
                                  },
                                  expression: "filterFailedPaidDateRange",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(scope.row.order_time) +
                                  "\n                "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1049314190
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "失败原因",
                      prop: "failure_reason",
                      width: "200",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header-title" }, [
                                _vm._v("失败原因"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    size: "mini",
                                    placeholder: "选择失败原因",
                                    filterable: "",
                                  },
                                  model: {
                                    value: _vm.selectedFailedReason,
                                    callback: function ($$v) {
                                      _vm.selectedFailedReason = $$v
                                    },
                                    expression: "selectedFailedReason",
                                  },
                                },
                                _vm._l(_vm.failedReasons, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(scope.row.failure_reason) +
                                  "\n                "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1329002121
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "机器人ID",
                      prop: "robot_id",
                      width: "180",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header-title" }, [
                                _vm._v("机器人ID"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    size: "mini",
                                    placeholder: "筛选机器人ID",
                                    clearable: "",
                                    filterable: "",
                                  },
                                  model: {
                                    value: _vm.filterFailedRobotId,
                                    callback: function ($$v) {
                                      _vm.filterFailedRobotId = $$v
                                    },
                                    expression: "filterFailedRobotId",
                                  },
                                },
                                _vm._l(
                                  _vm.failedTableFilters.robot_id,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(scope.row.robot_id) +
                                  "\n                "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      752742933
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "机器人名称",
                      prop: "robot_name",
                      width: "200",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "table-header-title" }, [
                                _vm._v("机器人名称"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    size: "mini",
                                    placeholder: "筛选机器人名称",
                                    clearable: "",
                                    filterable: "",
                                  },
                                  model: {
                                    value: _vm.filterFailedRobotName,
                                    callback: function ($$v) {
                                      _vm.filterFailedRobotName = $$v
                                    },
                                    expression: "filterFailedRobotName",
                                  },
                                },
                                _vm._l(
                                  _vm.failedTableFilters.robot_name,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(scope.row.robot_name) +
                                  "\n                "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3275365919
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "获客链接",
                      prop: "customer_link",
                      "min-width": "380",
                      align: "center",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.customer_link
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "copy-link",
                                      attrs: { title: scope.row.customer_link },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onCopyCustomerLink(
                                            scope.row.customer_link
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(scope.row.customer_link) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                : _c("span", [_vm._v("-")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2110465932
                    ),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "statistics" }, [
                _vm._v("\n            当前页总数："),
                _c("span", [_vm._v(_vm._s(_vm.displayFailedData.length))]),
              ]),
              _vm._v(" "),
              _c("el-pagination", {
                staticStyle: { "text-align": "right", "padding-top": "20px" },
                attrs: {
                  "current-page": _vm.failedTableCurrentPage,
                  "page-size": _vm.failedTablePerPage,
                  layout: "total, prev, pager, next, jumper",
                  "page-count": _vm.failedTableTotalPage,
                  total: _vm.failedTableTotal,
                },
                on: {
                  "current-change": _vm.changeFailedTablePage,
                  "update:currentPage": function ($event) {
                    _vm.failedTableCurrentPage = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.failedTableCurrentPage = $event
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }